import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const EnterpriseResourcePlanning = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">ERP System - Worldwide</h1>
                <p className="colorWht">Offering role-based access to critical applications, data, and analytical tools.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="content-dest">
          <div className="col-lg-12 content-dest-bg">
            <div className="col-lg-5 col-md-5 col-sm-6 padTB58 text-right">
              <img src="/images/enterprise_resource_planning.jpg" alt="enterprise resource planning" className="content-img" />
            </div>
            <div className="col-lg-3 col-md-3 col-sm-6 padTB58 padLR15 erp">
              <p>
                Offering role-based access to critical applications, data, and analytical tools, our enterprise resource management software drives competitiveness and streamlining business processes.
              </p>
              <ul className="pad0">
                <li>Increase competitiveness with integrated, fast, and flexible business processes</li>
                <li>Accelerate time to market with innovative, individualized products and services</li>
                <li>Simplify corporate structure, market channel, and business scenario management</li>
                <li>Improve corporate resource and asset utilization – for greater customer satisfaction</li>
                <li>Rely on a consolidated foundation for the latest mobile, cloud, and in-memory technologies</li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 bgwhite">
              <div className="dest-rightside ERP">
                <div>You may also be interested in <span> our other services</span></div>
                <ul className="pad0">
                  <li><Link to="/applications" title="Applications">Applications</Link></li>
                  <li><Link to="/consulting" title="Consulting">Consulting</Link></li>
                  <li><Link to="/mobility" title="Mobility">Mobility</Link></li>
                  <li><Link to="/business-process" title="Business Process">Business Process</Link></li>
                  <li><Link to="/gps-tracking-service" title="GPS Tracking as Service">GPS Tracking as Service</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h2>Product capabilities</h2>
                <h4>Functional capabilities</h4>
                <p>
                  <strong>Procure to Pay</strong><br />
                  Cut costs with support for end-to-end procurement and logistics processes
                </p>
                <p>
                  <strong>Core Finance</strong><br />
                  Streamline and automate your financial operations while ensuring regulatory compliance
                </p>
                <p>
                  <strong>Request to Service</strong><br />
                  Boost sales and customer satisfaction by delivering exceptional service in every customer experience
                </p>
                <p>
                  <strong>Order to Cash</strong><br />
                  Support customer-focused processes – from product sales to service delivery to warranty claims and returns
                </p>
                <p>
                  <strong>Plan to Product</strong><br />
                  Accelerate your entire process - from planning and scheduling to monitoring and analysis
                </p>
                <h4>Technical capabilities</h4>
                <p>
                  <strong>Applications</strong><br />
                  Best-in-class applications built around ERP integration
                </p>
                <p>
                  <strong>Cloud</strong><br />
                  Add-on cloud modules that integrate seamlessly with ERP
                </p>
                <p>
                  <strong>Mobile</strong><br />
                  A secure and intuitive mobile interface for ERP – available anytime, anywhere
                </p>
                <p>
                  <strong>Analytics</strong><br />
                  Integrated, real-time analytics based on reliable ERP data
                </p>
                <p>
                  <strong>Database and Technology</strong><br />
                  Tools, standards, speed, and flexibility that reduce landscape complexity
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default EnterpriseResourcePlanning;

